export default {
    api: {
        schema: 'http',
        port: 9999
    }
};


// WEBPACK FOOTER //
// ./src/configuration/config_common.js